import { render, staticRenderFns } from "./answer_form.vue?vue&type=template&id=7ec3a390&scoped=true&lang=pug&"
import script from "./answer_form.vue?vue&type=script&lang=js&"
export * from "./answer_form.vue?vue&type=script&lang=js&"
import style0 from "./answer_form.vue?vue&type=style&index=0&id=7ec3a390&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec3a390",
  null
  
)

export default component.exports